import { Checkbox } from "@coval/ui"
import { CheckSquare } from "lucide-react"

import { FilterPopover } from "@/components/filters/FilterPopover"
import { FilterTrigger } from "@/components/filters/FilterTrigger"

import { RUN_STATUSES } from "../../../status"
import { useRunsFilter } from "../../contexts/RunsFilterContext"
import type { FilterSectionProps } from "../../types/filters"

export const StatusFilterSection: React.FC<FilterSectionProps> = ({
  isOpen,
  onToggle,
}) => {
  const { statusFilters, addStatusFilter, removeStatusFilter } = useRunsFilter()

  const handleToggle = (status: string, checked: boolean) => {
    if (checked) {
      addStatusFilter(status)
    } else {
      removeStatusFilter(status)
    }
  }

  return (
    <FilterPopover
      isOpen={isOpen}
      onToggle={onToggle}
      width="w-72"
      trigger={
        <FilterTrigger
          label="Status"
          icon={<CheckSquare className="w-4 h-4" />}
          isActive={statusFilters.length > 0}
        />
      }
    >
      <div className="max-h-[50vh] overflow-y-auto">
        <div className="p-1.5">
          <div className="flex flex-col">
            {RUN_STATUSES.map((status) => (
              <label
                key={status}
                className="flex cursor-pointer items-center gap-2 rounded-sm px-2 py-1.5 text-sm text-coval-text hover:bg-surface-contrast"
              >
                <Checkbox
                  id={`status-${status}`}
                  checked={statusFilters.includes(status)}
                  onCheckedChange={(checked) =>
                    handleToggle(status, checked === true)
                  }
                  aria-label={status.toLowerCase()}
                />
                <span className="capitalize">{status.toLowerCase()}</span>
              </label>
            ))}
          </div>
        </div>
      </div>
    </FilterPopover>
  )
}
